import { PivotTableValue } from './raw-pivot-table.component';

// useful when dev-ing/debugging the pivot table

export const mockData = [
  {
    id: 1,
    containerNumber: 'CN001',
    amount: 100,
    buyer: 'Buyer1',
    week: '2022-W10',
  },
  {
    id: 2,
    containerNumber: 'CN001',
    amount: 100,
    buyer: 'Buyer1',
    week: '2022-W10',
  },
  {
    id: 3,
    containerNumber: 'CN001',
    amount: 100,
    buyer: 'Buyer1',
    week: '2022-W10',
  },
  {
    id: 4,
    containerNumber: 'CN002',
    amount: 100,
    buyer: 'Buyer1',
    week: '2022-W10',
  },
  {
    id: 5,
    containerNumber: 'CN002',
    amount: 100,
    buyer: 'Buyer1',
    week: '2022-W10',
  },
  {
    id: 6,
    containerNumber: 'CN002',
    amount: 100,
    buyer: 'Buyer2',
    week: '2022-W10',
  },
  {
    id: 7,
    containerNumber: 'CN004',
    amount: 100,
    buyer: 'Buyer2',
    week: '2022-W10',
  },
];

export const mockPossibleFields = [
  { field: 'id' },
  { field: 'containerNumber' },
  { field: 'amount' },
  { field: 'buyer' },
  { field: 'week' },
];

export const mockCols = [];
export const mockRows = [
  { field: 'buyer', total: true },
  { field: 'id', total: false },
  { field: 'containerNumber', total: true },
  { field: 'week', total: false },
];

export const mockValues: PivotTableValue[] = [
  { field: 'amount', operator: 'sum' },
];
